import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import Domain from "./Pages/Domain";
import IPAddress from "./Pages/IPAddress";
import DNSRecords from "./Pages/DNSRecords";
import Whois from "./Pages/Whois";
import VPSserver from "./Pages/VPSserver";
import Reseller from "./Pages/Reseller";
import Cloud from "./Pages/Cloud";
import SharedHosting from "./Pages/SharedHosting";
import CpanelHosting from "./Pages/CpanelHosting";
import PrivacyPolicy from "./Company/PrivacyPolicy";
import TermsAndConditions from "./Company/TermsAndConditions";
import FairUsagePolicy from "./Company/FairUsagePolicy";
import RefundPolicy from "./Company/RefundPolicy";
import About from "./Company/About";
import Affiliate from "./Company/Affiliate";
import Unlimitedhostingpolicy from "./Company/Unlimitedhostingpolicy";
import Acceptusagepolicy from "./Company/Acceptusagepolicy";
import SLA from "./Company/SLA";
import NameServer from "./Pages/NameServer";
import Sitemap from "./Pages/Sitemap";
import Error from "./Pages/Error";
import Career from "./Pages/Career";
import PingTest from "./Pages/PingTest";

// Geolocation Provider
import { GeoLocationProvider } from "./utils/useGeoLocation";

// Tawk.to initialization
import { initializeTawkTo } from "./utils/tawkto";

import "./css/about.css";
import "./css/mediaquery.css";

function App() {
  useEffect(() => {
    // Initialize Tawk.to when the app loads
    initializeTawkTo();
  }, []);

  return (
    <>
      <GeoLocationProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="*" element={<Error />} />
            <Route path="/" element={<Home />} />
            {/* <Route path="/home" element={<Home />} /> */}
            <Route
              path="/affordable-cpanel-hosting"
              element={<CpanelHosting />}
            />
            <Route path="/sharedHosting" element={<SharedHosting />} />
            <Route path="/cloud-based-hosting-services" element={<Cloud />} />
            <Route
              path="/affordable-reseller-web-hosting"
              element={<Reseller />}
            />
            <Route path="/affordable-linux-vps-hosting" element={<VPSserver />} />
            <Route path="/domain" element={<Domain />} />
            <Route path="/ip-address" element={<IPAddress />} />
            <Route path="/dns-records" element={<DNSRecords />} />
            <Route path="/whois" element={<Whois />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/nameserver" element={<NameServer />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/fair-usage-policy" element={<FairUsagePolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/about" element={<About />} />
            <Route path="/affiliate" element={<Affiliate />} />
            <Route path="/accept-usage-policy" element={<Acceptusagepolicy />} />
            <Route
              path="/unlimited-hosting-policy"
              element={<Unlimitedhostingpolicy />}
            />
            <Route path="/sla" element={<SLA />} />
            <Route path="/career" element={<Career />} />
            <Route path="/ping-test" element={<PingTest />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </GeoLocationProvider>
    </>
  );
}

export default App;
